<!--
  @description 字典管理
  @author xiehan
  @date 2018/12/17
-->
<template>
  <div class="dicManage__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('dicManage.group')">
        <el-input v-model="searchForm.group"></el-input>
      </el-form-item>
      <el-form-item :label="$t('dicManage.name')">
        <el-input v-model="searchForm.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="search"
          v-g-rac="gRac('dicManage_search')"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary"
          @click="addDic"
          v-g-rac="gRac('dicManage_add')"
          v-text="$t('common.add')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
    border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="dicDiaTitle"
      :visible.sync="dicDiaVis"
      width="400px">
      <el-form ref="handleForm" :model="handleForm" label-width="80px" input-width="180px" :rules="rules">
        <el-form-item :label="$t('dicManage.group')" prop="group">
          <el-input v-model="handleForm.group"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dicManage.code')" prop="code">
          <el-input v-model="handleForm.code"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dicManage.name')" prop="name">
          <el-input v-model="handleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dicManage.desc')" prop="desc">
          <el-input v-model="handleForm.desc"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dicDiaVis = false" v-text="$t('common.close')"></el-button>
        <el-button type="primary" @click="saveDic" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dicManageBiz from '@/logic/systemSetting/dicManageBiz'
  import table from '@/components/mixins/table'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac, table],
    data () {
      return {
        searchForm: {
          group: '',
          name: ''
        },
        tableControl: [
          {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(() => {
                dicManageBiz.deleteNewDictionary({ id: row.id }).then(() => {
                  this.successMessage()
                  this.searchTable()
                })
              }).catch(() => {})
            },
            rac: () => this.gRac('dicManage_delete')
          }, {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.editDic(row)
            },
            rac: () => this.gRac('dicManage_amend')
          }
        ],
        dicDiaTitle: '',
        dicDiaVis: false,
        handleForm: {
          group: '',
          code: '',
          name: '',
          desc: ''
        },
        rules: {
          group: [{ required: true, message: `${this.$t('common.entryTips')}${this.$t('dicManage.group')}` }],
          code: [{ required: true, message: `${this.$t('common.entryTips')}${this.$t('dicManage.code')}` }],
          name: [{ required: true, message: `${this.$t('common.entryTips')}${this.$t('dicManage.name')}` }],
          desc: [{ required: true, message: `${this.$t('common.entryTips')}${this.$t('dicManage.desc')}` }]
        },
        selectId: ''
      }
    },
    methods: {
      initTable () {
        this.tInitTable({
          lanKey: 'dicManage.table',
          head: ['group', 'code', 'name', 'desc'],
          requestFun: this.searchTable
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        dicManageBiz.findDic(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.desc = item.desc['zh-CN']
              item.name = item.name['zh-CN']
            })
          }
          this.tData = data
        })
      },
      addDic () {
        this.dicDiaTitle = this.$t('dicManage.addDic')
        this.dicDiaVis = true
        this.handleForm = {
          group: '',
          code: '',
          name: '',
          desc: ''
        }
        this.$nextTick(() => {
          this.$refs.handleForm.clearValidate()
        })
      },
      editDic (row) {
        this.dicDiaTitle = this.$t('dicManage.editDic')
        this.dicDiaVis = true
        this.handleForm = row
        this.selectId = row.id
      },
      saveDic () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid) {
            let eventName = this.dicDiaTitle === this.$t('dicManage.editDic')
              ? 'updateNewDictionary' : 'addNewDictionary'
            let saveObj = {
              group: this.handleForm.group,
              code: this.handleForm.code,
              chineseDesc: this.handleForm.desc,
              chineseName: this.handleForm.name
            }
            if (this.dicDiaTitle === this.$t('dicManage.editDic')) saveObj.id = this.selectId
            dicManageBiz[eventName](saveObj).then(data => {
              this.dicDiaVis = false
              this.successMessage()
              this.searchTable()
            })
          } else {
            return false
          }
        })
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      }
    },
    mounted () {
      this.initTable()
      this.searchTable()
    }
  }
</script>

<style scoped>

</style>